/**
 * @file schemas/organic-material-links.ts
 * @description 有機資材查詢連結字典 Zod schema 與預設清單（2026-09-01 回報序4）。
 *
 * 前端審查頁（/organic-materials、稽核任務有機資材審查卡片）讀取
 * GET /api/settings/organic-material-links?activeOnly=true；
 * 維護頁「系統設置 → 業務字典 — 有機資材查詢連結」增刪改。
 */
import { z } from 'zod';
/** 新增連結 */
export const createOrganicMaterialLinkSchema = z.object({
    /** 顯示名稱 */
    name: z.string().trim().min(1).max(100),
    /** 連結網址（僅允許 http/https，避免 javascript: 等危險協定） */
    url: z
        .string()
        .trim()
        .max(2000)
        .url('請輸入有效網址')
        .refine((v) => /^https?:\/\//i.test(v), '網址須以 http:// 或 https:// 開頭'),
    description: z.string().max(500).optional().nullable(),
    sortOrder: z.number().int().min(0).default(0),
    isActive: z.boolean().default(true),
});
/** 局部更新連結 */
export const updateOrganicMaterialLinkSchema = createOrganicMaterialLinkSchema.partial();
/**
 * 預設查詢連結（字典表為空時由 API 首次讀取自動寫入；前端離線 / 讀取失敗時亦以此回落）。
 * 皆為政府 / 學術單位公開查詢系統。
 */
export const DEFAULT_ORGANIC_MATERIAL_LINKS = [
    {
        name: '農業部農糧署－肥料管理整合資訊系統',
        url: 'https://fims.afa.gov.tw/WFR/PublicFun/QueryFertBrand.aspx',
    },
    {
        name: '農業部動植物防疫檢疫署－農藥資訊服務網（農藥許可證查詢）',
        url: 'https://pesticide.aphia.gov.tw/information/Query/Register',
    },
    {
        name: '農業部動植物防疫檢疫署－農藥資訊服務網（免登記植物保護資材專區）',
        url: 'https://pesticide.aphia.gov.tw/information/Query/ProtectNew',
    },
    {
        name: '國立中興大學農產品驗證中心（有機農業商品化資材）',
        url: 'https://apacctw.org/APACSWeb/materials/2/1/%E8%B3%87%E6%9D%90%E9%81%B4%E9%81%B8%E4%B8%80%E8%A6%BD%E8%A1%A8.html',
    },
];
